import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

export interface TransactionStatusData {
  data: any;
}

@Component({
  selector: 'app-transaction-status',
  templateUrl: './transaction-status.html',
  styleUrls: ['./transaction-status.scss'],
})
export class TransactionStatus implements OnInit {
  confirmButtonColor: string = 'warn';

  dataSource: {
    id: number;
    [key: string]: any;
  } = {
    id: null,
  };
  errorFlag: boolean = false;
  message: any = null;

  constructor(
    private httpClient: HttpClient,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<TransactionStatus>,
    @Inject(MAT_DIALOG_DATA) public data: TransactionStatusData
  ) {}

  ngOnInit() {
    this.dataSource = this.data.data.data;
    this.message = this.data.data.message;
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
